// modules
import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import {
  FacebookShareButton,
  TwitterShareButton,
  FacebookIcon
} from 'react-share';

// X公式ロゴSVGコンポーネント
const XIcon = ({ size = 32, round = false, ...props }) => {
  const iconStyle = {
    width: `${size}px`,
    height: `${size}px`,
    backgroundColor: '#000000',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: round ? '50%' : '0',
    padding: '6px'
  };

  return (
    <div style={iconStyle} {...props}>
      <svg
        viewBox="0 0 24 24"
        fill="white"
        width={`${size * 0.45}px`}
        height={`${size * 0.45}px`}
      >
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    </div>
  );
};

// styles
import {
  ModalAppButton,
  ModalCancelButton,
  ModalShare
} from '../../../styles/app';

class ConfirmModal extends React.Component {

  render() {
    const {
      handleConfirmed,
      isOpen,
      toggle,
      message,
      okButtonText,
      cancelButtonText,
      nestedModal,
      shareButtonUrl
    } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {(() => {
            if (shareButtonUrl) {
              return(
                <ModalShare>
                  <TwitterShareButton
                    title={'TIGET plus で活動を一瞬で届ける準備が整いました！' + '\n'}
                    url={shareButtonUrl}
                    via='tigetplus'
                    style={{verticalAlign: 'top', marginTop: '1px'}}>
                    <XIcon size={31} round={true} />
                  </TwitterShareButton>
                  <FacebookShareButton
                    quote='TIGET plus で活動を一瞬で届ける準備が整いました！'
                    url={shareButtonUrl}
                    style={{marginLeft: '10px', verticalAlign: 'top'}}>
                    <FacebookIcon size={32} round={true} />
                  </FacebookShareButton>
                </ModalShare>
              )
            }
          })()}
        </ModalHeader>
        <ModalBody>
        {message}
        {nestedModal}
        </ModalBody>
        <ModalFooter>
          <ModalAppButton onClick={handleConfirmed}>
            {(() => {
              return okButtonText || 'OK'
            })()}
          </ModalAppButton>
          <ModalCancelButton onClick={toggle}>
            {(() => {
              return cancelButtonText || 'キャンセル'
            })()}
          </ModalCancelButton>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ConfirmModal;
